import { Button } from '@carto/meridian-ds/components'
import { Box, Paper, styled } from '@mui/material'
import ModalWrapper from 'features/common/ui/utils/ModalWrapper'
import { ReactElement, ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import BuilderHeader from 'features/builder/ui/BuilderPrivate/BuilderHeader/BuilderHeader'
import { isInIframe } from 'app/utils/embedding'

const Page = styled(Box)(() => ({
  width: '100%',
  height: '100vh',
  '.MuiPopper-root': {
    zIndex: 9999
  }
}))

const HeaderWrapper = styled(Box)(() => ({
  '& header': {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%'
  }
}))

const LoginPaper = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexFlow: 'column',
  maxWidth: theme.spacing(51.5),
  minWidth: theme.spacing(51.5)
}))

interface NoPermissionsPromptProps {
  children: ReactNode
  brandText?: ReactElement
  logoPositive?: boolean
}

function NoPermissionsPrompt({ logoPositive, brandText, children }: NoPermissionsPromptProps) {
  const hideBackdrop = !!logoPositive

  return (
    <Page>
      <ModalWrapper open={true} displayCloseIcon={false} closeOnBackdrop={false} hideBackdrop={hideBackdrop}>
        <HeaderWrapper>
          <BuilderHeader viewOnly dontShowTitle brandText={brandText} />
        </HeaderWrapper>
        <LoginPaper elevation={24}>
          <Box flex={1}>{children}</Box>
          <Box p={2} textAlign="right">
            <Button component="a" href="/" variant="contained" target={isInIframe ? '_blank' : undefined}>
              <FormattedMessage id="builder.navBar.titleTooltip" />
            </Button>
          </Box>
        </LoginPaper>
      </ModalWrapper>
    </Page>
  )
}

export default NoPermissionsPrompt
